import { Button } from '@material-ui/core'

interface Props {
  onClick: () => void
}

export function GoToSearchButton({ onClick }: Props) {
  return (
    <Button className="faq-go-to-search" color="primary" onClick={onClick}>
      検索結果一覧に戻る
    </Button>
  )
}
